"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.modifiers = void 0;
var modifiers = exports.modifiers = [{
  name: 'offset',
  options: {
    offset: [10, 20]
  }
}, {
  name: 'computeStyles',
  options: {
    gpuAcceleration: false
  }
}];